'use client';
import { ChangeEvent, useEffect, useState } from 'react';
import { SelectArrow } from './SelectArrow';

type SelectProps = {
  id: string;
  options: { value: string; label: string }[];
  selectedOption?: string;
  ariaLabel?: string;
  required?: boolean;
  onChange?: (event: ChangeEvent<HTMLSelectElement>) => void;
  label?: string;
};

export const Select = ({
  id,
  selectedOption,
  onChange,
  options,
  ariaLabel = '',
  required = true,
  label,
}: SelectProps) => {
  const [value, setValue] = useState(selectedOption);

  useEffect(() => {
    setValue(selectedOption);
  }, [selectedOption]);

  const handleOnChange = (event: ChangeEvent<HTMLSelectElement>) => {
    setValue(event.target.value);
    onChange && onChange(event);
  };

  return (
    <>
      {label && (
        <label htmlFor={id} className="mb-1 text-sm font-semibold text-white">
          {label}
        </label>
      )}
      <div className="relative flex items-center rounded border border-grey-600 text-white ">
        <select
          id={id}
          className="h-10 w-full appearance-none bg-transparent pl-2 pr-10 text-white"
          onChange={handleOnChange}
          required={required}
          aria-label={ariaLabel}
          value={value}
        >
          {options.map((option) => {
            return (
              <option
                className="text-black"
                key={option.value}
                value={option.value}
                data-test="select-option"
                data-test-value={option.value}
              >
                {option.label}
              </option>
            );
          })}
        </select>
        <SelectArrow
          aria-hidden="true"
          stroke="currentColor"
          className="pointer-events-none absolute right-2.5"
        />
      </div>
    </>
  );
};
